module.exports = __webpack_public_path__ + "static/media/mug-marshmallows.0bfdbec3.svg";